export default "__VITE_ASSET__t8dJvmHo__"